export default window.$environment
